export function timeSince(timestamp: number): string {
  const now = Date.now(); // Current time in milliseconds
  const date = new Date(timestamp); // Convert timestamp to Date

  if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid timestamps

  const seconds = Math.floor((now - timestamp) / 1000);

  if (seconds < 0) return "Just now"; // Future timestamp handling

  const intervals = [
    { seconds: 31536000, label: "years" },
    { seconds: 2592000, label: "months" },
    { seconds: 86400, label: "days" },
    { seconds: 3600, label: "hours" },
    { seconds: 60, label: "minutes" },
    { seconds: 1, label: "seconds" }
  ];

  for (const { seconds: unitSeconds, label } of intervals) {
    const interval = Math.floor(seconds / unitSeconds);
    if (interval >= 1) {
      return `${interval} ${label} ago`;
    }
  }

  return "Just now"; // If the difference is too small
}
